import { useQuery } from '@/hooks/query.hook';
import HistoryChatBox from '../chatGPT/history-chat-box';

export default function HistoryChatBotPermission() {
  const { mode } = useQuery();

  const renderContent = () => {
    switch (mode) {
      default:
        return <HistoryChatBox />;
    }
  };
  return <>{renderContent()}</>;
}
